import React, { useState, useEffect } from "react"
import Section from "../../../core/layout/main/section/Section"
import * as classNames from "./CtxJobSectorPersons.module.scss"
import Button from "../../common/blocks/button/Button"
import ImageVideo from "../../../core/image-video/ImageVideo"
const CtxJobSectorPersons = ({
  PersSectActTitle,
  PersSectActUnderTitle,
  CardNumber,
  interviews,
}) => {
  const [chunkedArray, setChunkedArray] = useState([])

  useEffect(() => {
    setChunkedArray(interviews.slice(0, 3))
  }, [interviews || CardNumber])

  function renderInterview(interview, index) {
    if (index % 2 === 0) {
      return (
        <>
          <div
            key={index}
            className="row flex align-items-center mt-md-8"
          >
            <div
              key={interview.id}
              className="col mt-4 mt-md-0"
            >
              <div className="pr-md-8">
                <h3>{interview.title}</h3>
                <p className="mt-3">{interview.description}</p>
                {interview.Button && (
                  <Button
                    color={interview.Button.color}
                    to={
                      interview.Button?.simplePage?.data?.attributes?.route
                        ? interview.Button?.simplePage?.data?.attributes?.route
                        : "#"
                    }
                    size={interview.Button.taille}
                    aspect={interview.Button.style}
                    className={`${classNames.buttonSize} mt-3`}
                  >
                    {interview.Button.text}
                  </Button>
                )}
              </div>
            </div>
            <div className="col mt-4 mt-md-0">
              <ImageVideo imageVideoData={interview.video} />
            </div>
          </div>
        </>
      )
    } else {
      return (
        <div
          key={index}
          className="row flex align-items-center mt-md-8"
        >
          <div className="col mt-4 mt-md-0">
            <ImageVideo imageVideoData={interview.video} />
          </div>
          {interview.Button && (
            <div
              key={interview.id}
              className="col mt-4 mt-md-0"
            >
              <div className="pl-md-8">
                <h3>{interview.title}</h3>
                <p className="mt-3">{interview.description}</p>
                <Button
                  color={interview.Button.color}
                  to={
                    interview.Button?.simplePage?.data?.attributes?.route
                      ? interview.Button?.simplePage?.data?.attributes?.route
                      : "#"
                  }
                  size={interview.Button.taille}
                  aspect={interview.Button.style}
                  className={`${classNames.buttonSize} mt-3`}
                >
                  {interview.Button.text}
                </Button>
              </div>
            </div>
          )}
        </div>
      )
    }
  }

  return (
    <>
      <div className={"mb-4"}>
        <Section
          container
          className={
            "secondary-background-color pbl-8 " +
            classNames.rhSectionMediaVideos
          }
        >
          <div className="text-center">
            <h2 className="text-center">{PersSectActTitle}</h2>
            <p className="mt-3">{PersSectActUnderTitle}</p>
          </div>

          {chunkedArray.map((item, subIndex) =>
            renderInterview(item, subIndex)
          )}
        </Section>
      </div>
    </>
  )
}
export const name = "CtxJobSectorPersons"

export const init = (componentData, pageContext) => {
  return (
    <CtxJobSectorPersons
      key={componentData.id}
      PersSectActTitle={`${pageContext.itemData?.attributes.label} !`}
      PersSectActUnderTitle={pageContext.itemData?.attributes.description}
      BlocNumber={componentData.BlocNumber}
      CardNumber={componentData.CardNumber}
      interviews={
        pageContext.itemData?.attributes.Interviews
          ? pageContext.itemData?.attributes.Interviews
          : []
      }
    />
  )
}

export default CtxJobSectorPersons
